import React, { useEffect, useState } from 'react';
import { BarWave } from 'react-cssfx-loading';
import IssueForm from '../components/occurrenceForms/IssueForm';
import IncidentForm from '../components/occurrenceForms/IncidentForm';
import HazardForm from '../components/occurrenceForms/HazardForm';
// import { useAddOccurrenceMutation } from '../../redux/public/publicSlice';
import { useAddOccurrenceMutation } from '../../redux/apiSlice';
import NormalButton from '../../components/Buttons/NormalButton';

function ReportOccurence() {
  const [newOccurrence, setNewOccurrence] = useState({
    occurrence: '',
    category: '',
    main_category: '',
    place: '',
    date_reported: '',
    status: 1,
    time: '',
    brief_notes: '',
    recommendation: '',
    reported_by: '',
    reported_by_name: '',
    reported_by_id: '',
    reported_by_department: '',
    reported_by_tel: '',
    reported_by_email: '',
  });

  if (localStorage.getItem('ans-sms')) {
    newOccurrence.reported_by_id = JSON.parse(localStorage.getItem('ans-sms')).user;
    newOccurrence.reported_by = JSON.parse(localStorage.getItem('ans-sms')).username;
    newOccurrence.reported_by_name = JSON.parse(localStorage.getItem('ans-sms')).name;
  }

  const [addOccurrence, transaction] = useAddOccurrenceMutation();

  const [selectedDefinition, setSelectedDefinition] = useState();
  const [activeTab, setActiveTab] = useState();
  const [errorMessage, setErrorMessage] = useState('');

  // Set the default form to 'issue' and its corresponding definition when the component mounts
  useEffect(() => {
    setActiveTab('issue');
    setSelectedDefinition('An issue is a problem or concern that needs to be addressed');
  }, []);

  if (activeTab === 'issue') {
    newOccurrence.main_category = 'Issue';
  } else if (activeTab === 'incident') {
    newOccurrence.main_category = 'Incident';
  } else if (activeTab === 'hazard') {
    newOccurrence.main_category = 'Hazard';
  }

  const handleChange = (e) => {
    e.preventDefault();
    setErrorMessage('');
    setNewOccurrence({
      ...newOccurrence,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newOccurrence.occurrence === '' || newOccurrence.category === '' || newOccurrence.date_reported === '' || newOccurrence.brief_notes === '' || newOccurrence.recommendations === '' || newOccurrence.time === '') {
      setErrorMessage('Please fill in all fields');
      return;
    }
    const currDate = new Date();
    const currentDate = currDate.toISOString().split('T')[0];
    if (newOccurrence.date_reported > currentDate) {
      setErrorMessage('Date reported cannot be in the future');
      return;
    }
    addOccurrence(newOccurrence);
  };

  const handleTab = (e) => {
    const selectedTab = e.target.id;
    setActiveTab(selectedTab);

    // Update the selectedDefinition based on the selected tab
    if (selectedTab === 'issue') {
      setSelectedDefinition('An issue is a problem or concern that needs to be addressed');
      newOccurrence.main_category = 'Issue';
    } else if (selectedTab === 'incident') {
      setSelectedDefinition(
        'An incident is an occurrence, other than an accident, associated with the operation of an aircraft which affects or could affect the safety of operation',
      );
      newOccurrence.main_category = 'Incident';
    } else if (selectedTab === 'hazard') {
      setSelectedDefinition(
        'A hazard is a condition or an object with the potential to cause or contribute to an aircraft incident or accident',
      );
      newOccurrence.main_category = 'Hazard';
    }
  };

  let successMessage;
  if (transaction.isSuccess) {
    switch (activeTab) {
      case 'issue':
        successMessage = 'Issue added successfully';
        break;
      case 'incident':
        successMessage = 'Incident added successfully';
        break;
      case 'hazard':
        successMessage = 'Hazard added successfully';
        break;
      default:
        successMessage = 'Occurrence added successfully';
    }
  }

  let content;

  if (transaction.isLoading) {
    content = <BarWave color="#54c5fc" height="1rem" width="6rem" className="mt-48" />;
  } else if (transaction.isError) {
    content = <div className="text-red-500 font-bold mt-48 text-center">An error occurred while adding the occurrence</div>;
  } else if (transaction.isSuccess) {
    content = (
      <div className="text-green-500 font-bold mt-4 text-center" style={{ fontSize: '44px' }}>
        {successMessage}
      </div>
    );
  } else {
    content = (
      <>
        <div className="flex flex-col border-r border-l border-b border-blue-500 items-center p-2 mb-4 xl:w-3/4 w-full">
          {activeTab === 'hazard' && <HazardForm handleChange={handleChange} />}
          {activeTab === 'incident' && <IncidentForm handleChange={handleChange} />}
          {activeTab === 'issue' && <IssueForm handleChange={handleChange} />}
        </div>
        {errorMessage && (
          <div className="text-red-500">{errorMessage}</div>
        )}
        <div className="xl:w-3/4 w-full px-8 flex flex-col items-center">
          <NormalButton action={handleSubmit} buttonText="Report Now" />
        </div>
      </>
    );
  }

  return (
    <div className="flex flex-col items-center md:p-4 p-2 mt-16 xl:mx-24 md:mx-16 mx-4 min-h-screen">
      <div className="flex flex-col items-center p-2">
        <h2 className="xl:text-4xl lg:text-2xl md:text-xl text-lg items-center mt-2 mb-4 font-bold">Report an occurrence</h2>
        <p className="xl:text-xl md:text-md text-sm">Report an aircraft or workplace occurrence as an issue, incident, or hazard</p>
      </div>

      {/* Container for definition and navbar */}
      <div className="sticky pt-2 xl:w-3/4 w-full">
        {/* Nav bar */}
        <nav className=" w-full xl:h-32 md:h-36 h-32 flex flex-col items-center bg-blue-500 xl:px-20 md:px-10 px-5 py-2 mb-4">
          <ul className="flex flex-row space-x-4 text-white cursor-pointer w-full text-bold">
            <button
              onClick={handleTab}
              id="issue"
              type="button"
              className={`rounded-lg xl:py-4 py-2 flex-col items-center g-amber-400 xl:p-4 p-2 xl:px-8 md:px-4 px-2 w-1/3 ${
                activeTab === 'issue' ? 'text-white md:text-xl text-md' : 'text-blue-900 md:text-lg text-sm font-light border-b border-blue-900'
              }`}
            >
              Issue
            </button>
            <button
              onClick={handleTab}
              id="incident"
              type="button"
              className={`rounded-lg xl:py-4 py-2 flex-col items-center g-amber-400 xl:p-4 p-2 xl:px-8 md:px-4 px-2 w-1/3 ${
                activeTab === 'incident' ? 'text-white md:text-xl text-md' : 'text-blue-900 text-bold md:text-lg text-sm font-light border-b border-blue-900'
              }`}
            >
              Incident
            </button>
            <button
              onClick={handleTab}
              id="hazard"
              type="button"
              className={`rounded-lg xl:py-4 py-2 flex-col items-center g-amber-400 xl:p-4 p-2 xl:px-8 px-4 w-1/3 ${
                activeTab === 'hazard' ? 'text-white md:text-xl text-md' : 'text-blue-900 md:text-lg text-sm font-light border-b border-blue-900'
              }`}
            >
              Hazard
            </button>
          </ul>
          <p className="text-white lg:text-md md:text-sm text-xs xl:py-4 py-2">
            { selectedDefinition }
          </p>
        </nav>
      </div>

      {content}
    </div>
  );
}
export default ReportOccurence;
